import { Building2 } from 'lucide-react'
import { useAppAuth } from '@/contexts/app-auth.context'
import { SuperAdminCompanySwitcher } from '@/components/company/SuperAdminCompanySwitcher'
import { CurrentCompanyDisplay } from '@/components/company/CurrentCompanyDisplay'
import { CompanySwitcherSkeleton } from '@/components/company/CompanySwitcherSkeleton'
import { useSidebar } from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'

export function SidebarTeam() {
  const {
    isSuperAdmin,
    isPartner,
    currentCompany,
    isAuthLoading,
    isCompanyLoading,
    isInitialized,
  } = useAppAuth()
  const { state } = useSidebar()
  const isCollapsed = state === 'collapsed'

  // Show skeleton loader during initial load or when still loading
  if (!isInitialized || isAuthLoading || isCompanyLoading) {
    return <CompanySwitcherSkeleton />
  }

  // If user is Super Data Admin, show the enhanced company switcher
  if (isSuperAdmin) {
    return <SuperAdminCompanySwitcher />
  }

  // Otherwise, show current company display
  if (currentCompany) {
    return (
      <CurrentCompanyDisplay company={currentCompany} isPartner={isPartner} />
    )
  }

  // Fallback - only show this if we're fully loaded and still have no company
  return (
    <div
      className={cn(
        'flex items-center gap-2 px-2 py-1.5 text-muted-foreground transition-all duration-200',
        isCollapsed && 'justify-center',
      )}
    >
      <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border bg-muted text-sm font-medium">
        <Building2 className="h-4 w-4" />
      </div>
      {!isCollapsed && <span className="text-sm">No company loaded</span>}
    </div>
  )
}
